import { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { mergePublicTheme, publicThemeVars } from '../publicTheme';
import Storefront from './Storefront';
import PublicCita from './PublicCita';
import PublicTicket from './PublicTicket';
import PublicNews from './PublicNews';

const center = { maxWidth: '480px', margin: '0 auto', padding: '3rem 1.5rem', textAlign: 'center' };

// El link único (/p/:slug) reúne todas las secciones de la empresa. La sección
// se elige por la URL (/p/:slug/:section) y, si no se indica, se muestra la
// primera activa — todo bajo /p para que el cliente vea siempre el mismo link y
// la barra de navegación lo lleve al resto sin cambiar a las rutas antiguas.
const SECTIONS = {
  tienda: { flag: 'tienda_activa',  Comp: Storefront },
  cita:   { flag: 'cita_activa',    Comp: PublicCita },
  news:   { flag: 'news_activa',    Comp: PublicNews },
  ticket: { flag: 'tickets_activa', Comp: PublicTicket },
};
const ORDER = ['tienda', 'cita', 'news', 'ticket'];

function PublicPortal() {
  const { slug, section } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetch(`/api/portal/${encodeURIComponent(slug)}`)
      .then(r => (r.ok ? r.json() : Promise.reject()))
      .then(setData)
      .catch(() => setNotFound(true));
  }, [slug]);

  const theme = mergePublicTheme(data?.theme);
  const wrap = { minHeight: '100vh', backgroundColor: theme.colors.background, color: theme.colors.text, ...publicThemeVars(theme.colors) };

  if (notFound) return <div style={wrap}><main style={{ ...center, color: theme.colors.textMuted }}>Empresa no encontrada.</main></div>;
  if (!data) return <div style={wrap}><main style={{ ...center, color: theme.colors.textMuted }}>Cargando...</main></div>;

  const firstActive = ORDER.find(k => data[SECTIONS[k].flag]);
  if (!firstActive) {
    return (
      <div style={wrap}>
        <main style={{ ...center, color: theme.colors.textMuted }}>
          {data.logo && <img src={data.logo} alt={data.name} style={{ width: '72px', height: '72px', objectFit: 'contain', borderRadius: '12px', marginBottom: '1rem' }} />}
          <h1 style={{ color: theme.colors.primary, fontSize: '1.4rem', margin: '0 0 0.5rem' }}>{data.name}</h1>
          <p>Esta empresa aún no tiene secciones públicas activas.</p>
        </main>
      </div>
    );
  }

  // ¿La sección de la URL existe y está activa? Si no, llevamos a la primera activa.
  const valid = section && SECTIONS[section] && data[SECTIONS[section].flag] ? section : null;
  if (section && !valid) return <Navigate to={`/p/${encodeURIComponent(slug)}/${firstActive}`} replace />;

  const Comp = SECTIONS[valid || firstActive].Comp;
  return <Comp />;
}

export default PublicPortal;
